import { HttpRequest } from '../../components/HttpRequest';
import secureLocalStorage from 'react-secure-storage';

const baseUrl = process.env.REACT_APP_BASE_URL;

export const authApi = {
  /**
   * Login user with email and password
   */
  async login(email, password) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: '/posLoginVersion2',
        body: {
          userPin: password,
          email: email,
          fcmToken: "cLyPjpl0TGSBb-HNCXe-ia:APA91bGRikYPEZvFG5DiLmg0ciO4WQpqAOSyBYiSSU0I2R7YFyqnpNV9Jy6LML_zs9uu1JrRRAtUUC1as45Owbx0Xb5txiQQWlgKw7VJOK2o_en4ZE0dB49kOKeLjhlpnuz8lWNwAELd",
          deviceId: "WEB",
          isEcommerce: true,
          ecommerceBusinessNo: secureLocalStorage.getItem("businessId")
        }
      });
      return response;
    } catch (error) {
      console.error('Login API error:', error);
      throw error;
    }
  },

  /**
   * Get new token after login for branch switching
   */
  async getNewTokenAfterLogin(branchId, oldToken) {
    try {
      const response = await fetch(baseUrl + `/api/get_token_after_invite`, {
        method: "POST",
        headers: {
          "X-Authorization": oldToken,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({
          branchId: branchId,
          isEcommerce: true,
          ecommerceBusinessNo: secureLocalStorage.getItem("businessId")
        }),
        signal: AbortSignal.timeout(30000),
      });
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error getting new token:', error);
      return null;
    }
  },

  /**
   * Register new user
   */
  async register(userData) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: '/api/v1/ecommerce/zedcustomeradd',
        body: {
          firstName: userData.firstName,
          lastName: userData.lastName,
          email: userData.email.trim(),
          phone: userData.phone,
          userName: userData.firstName + userData.lastName,
          password: userData.password,
          businessId: secureLocalStorage.getItem("businessId")
        }
      });
      return response;
    } catch (error) {
      console.error('Registration API error:', error);
      throw error;
    }
  },

  /**
   * Request password reset
   */
  /**
   * Finish the forced pin->password migration: the restricted setup token from
   * login is the only credential this endpoint accepts.
   */
  async setupPassword(setupToken, newPassword) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: '/api/v1/users/password/setup',
        body: { newPassword },
        headers: { 'X-Authorization': setupToken },
      });
      return response;
    } catch (error) {
      console.error('Password setup API error:', error);
      throw error;
    }
  },

  async requestPasswordReset(email) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: '/api/v1/ecommerce/forgot-password',
        body: {
          email: email,
          businessNumber: secureLocalStorage.getItem("businessId")
        }
      });
      return response;
    } catch (error) {
      console.error('Password reset API error:', error);
      throw error;
    }
  },

  /**
   * Verify reset code
   */
  async verifyResetCode(email, code) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: '/api/v1/ecommerce/verify-reset-code',
        body: {
          email: email,
          code: code,
          businessNumber: secureLocalStorage.getItem("businessId")
        }
      });
      return response;
    } catch (error) {
      console.error('Verify reset code API error:', error);
      throw error;
    }
  },

  /**
   * Reset password with code
   */
  async resetPassword(email, code, newPassword) {
    try {
      const response = await HttpRequest({
        method: 'POST',
        url: '/api/v1/ecommerce/reset-password',
        body: {
          email: email,
          code: code,
          newPassword: newPassword,
          businessNumber: secureLocalStorage.getItem("businessId")
        }
      });
      return response;
    } catch (error) {
      console.error('Reset password API error:', error);
      throw error;
    }
  },

  /**
   * Logout user
   */
  async logout() {
    try {
      // Clear all secure storage
      secureLocalStorage.clear();
      return { success: true };
    } catch (error) {
      console.error('Logout error:', error);
      throw error;
    }
  }
};